import React from 'react';
import BasePage from '@/components/BasePage';
import BaseLayout from '@/components/layouts/BaseLayout';
import { Container } from 'reactstrap';
import Booking from '@/components/Booking';

// Translation Higher Order Component
import { translate } from 'react-switch-lang';
const Recommendations = ({ t }) => {
	return (
		//React.Fragment is used instead of <div> or <> to hide it from source
		<React.Fragment>
			<BaseLayout
				className="cover"
				title={t('authorities.title')}
				description={`${t('authorities.text1')} ${t('authorities.text2')} ${t('authorities.text3')}`}
				keywords={`${t('SEO.keywords_common')} ${t('SEO.keywords_recommendations')}`}
				canonical="/recommendations"
			>
				{/* Base Page - Shared component with Container */}
				<BasePage id="agreements-page" className="agreements-page" role="article">
					<Container>
						<article>
							<h1 className="page_text font-weight-bold">{t('authorities.title')}</h1>
							<p>{t('authorities.text1')}</p>
							<p>{t('authorities.text2')}</p>
							<p>{t('authorities.text3')}</p>
							<p>{t('authorities.text4')}</p>
							<p>{t('authorities.text5')}</p>
							<p>{t('authorities.text6')}</p>
							<p>{t('authorities.text7')}</p>
							<p>{t('authorities.text8')}</p>
							<p>{t('authorities.text9')}</p>
							<p>{t('authorities.text10')}</p>
							<p>{t('authorities.text11')}</p>
							<p>{t('authorities.text12')}</p>
							<hr className="vaccination-page_hr" />
							<p>{t('authorities.text13')}</p>
						</article>
						<Booking />
					</Container>
				</BasePage>
			</BaseLayout>
		</React.Fragment>
	);
};
export default translate(Recommendations);
